import { Filter, BaseFilter, FilterParam } from '../../containers/search-filters/types';

export const processFiltersFromResponse = (
  filters?: Omit<Filter, 'fieldType'>[],
  defaultValueConfig?: Record<string, string>
): Filter[] | undefined => {
  if (!filters) return filters;

  return filters.reduce((prevFilters, filter) => {
    /**
     * In case of no filter parameters, it's of no use since it cannot have any change in result
     */
    if (filter.params.length === 0) {
      return prevFilters;
    }

    /**
     * Currently we are using "[]" as last characters to identify checkbox params
     */
    if (filter.id.endsWith('[]')) {
      prevFilters.push({
        ...filter,
        id: filter.id.slice(0, -2), // Here -2 is the length of "[]" string
        fieldType: 'checkbox',
      });
    } else {
      const isRangeType =
        filter.params.length === 2 &&
        filter.params.filter((param) => param.label.endsWith('[min]') || param.label.endsWith('[max]')).length === 2;
      if (isRangeType) {
        prevFilters.push({
          ...filter,
          fieldType: 'number-range',
          params: filter.params.map((param) => ({
            label: param.label,
            value: param.value || 0,
          })) as [FilterParam, FilterParam],
        });
      } else {
        prevFilters.push({
          ...filter,
          fieldType: 'radio',
          defaultValue:
            defaultValueConfig && defaultValueConfig[filter.id]
              ? defaultValueConfig[filter.id]
              : filter.params.find((param) => param.value === '')
              ? ''
              : filter.params[0].value.toString(),
        });
      }
    }
    return prevFilters;
  }, [] as Filter[]);
};

export const transformPaginatedResponseFilters = <T extends { filter?: Filter[] | Omit<Filter, 'fieldType'>[] }>(
  response: T
): typeof response => {
  response.filter = processFiltersFromResponse(response.filter);
  return response;
};

export const getParamsFromRangeFilter = (
  filter: BaseFilter<string> & {
    fieldType: 'number-range';
    params: [FilterParam, FilterParam];
  }
): [FilterParam | undefined, FilterParam | undefined] => {
  const minParam = filter.params.find((param) => param.label.endsWith('[min]'));
  const maxParam = filter.params.find((param) => param.label.endsWith('[max]'));
  return [minParam, maxParam];
};
